export default __webpack_public_path__ + "static/media/404.9b31d3de.png";